/**
 * @generated SignedSource<<2d31af0b80f1dc3e429ab1322119fe04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionBinAndBid_viewer$data = {
  readonly isMultiItemCart: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionActionBinAndBid_viewer";
};
export type PdpSharedAuctionActionBinAndBid_viewer$key = {
  readonly " $data"?: PdpSharedAuctionActionBinAndBid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionBinAndBid_viewer",
  "selections": [
    {
      "alias": "isMultiItemCart",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "30429409b07615b4879d75946a63e3b3";

export default node;
